// snippet: rcep
import { withStyles } from '@material-ui/core/styles';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './AdminKioskVerifyMain.styles';
import { Paper } from '@material-ui/core';

import AdminKioskVerifyFormContainer from './AdminKioskVerifyFormContainer';

export class AdminKioskVerifyMain extends Component {
  static propTypes = {
    test: PropTypes.string
  };
  render() {
    const { classes } = this.props;

    return (
      <div>
        <Paper className={classNames(classes.container)}>
          <AdminKioskVerifyFormContainer />
        </Paper>
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(AdminKioskVerifyMain);
